import { defineMessages } from "react-intl"

export const listingDescriptionFieldMessages = defineMessages({
	listingDescriptionDescription: {
		defaultMessage:
			"Remark: The description text should contain highlights of the vehicle and listing details " +
			"(e. g. incl. winter tyres). The text is visible to customers.",
		id: "listingDescription.explanation",
	},
	listingDescriptionLabel: {
		defaultMessage: "Vehicle description",
		id: "listingDescription.label",
	},
})
